import { TFunction } from "i18next";
import { OccurrenceSlot } from "../models/OccurrenceSlot";
import { SessionSystemLine } from "../models/SessionSystemLine";

/**
 * An occurrence's start in the reader's language and zone ("Tue, 3 Nov, 18:30"). The zone is the
 * browser's unless a test passes one; the Session's own zone is never forced on the reader.
 */
export const formatOccurrence = (slot: OccurrenceSlot, language: string, timeZone?: string): string =>
  new Intl.DateTimeFormat(language, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    timeZone,
  }).format(slot.startsAt);

/** The sentence a system line reads as, in the reader's language and zone; built on every render. */
export const systemLineText = (
  line: SessionSystemLine,
  sessionName: string,
  t: TFunction,
  language: string,
  timeZone?: string,
): string => {
  const at = (slot: OccurrenceSlot | null): string => (slot ? formatOccurrence(slot, language, timeZone) : "");
  const member = line.memberName ?? t("messages.system.someone");
  switch (line.type) {
    case "OccurrenceMoved":
      return t("messages.system.occurrenceMoved", { sessionName, from: at(line.from), to: at(line.to) });
    case "OccurrenceCancelled":
      return t("messages.system.occurrenceCancelled", { sessionName, from: at(line.from) });
    case "SeatConfirmed":
      return t("messages.system.seatConfirmed", { member });
    case "SeatCancelled":
      return t("messages.system.seatCancelled", { member });
  }
};
